// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"c190f143","869":"24fd89e7"}[chunkId] + ".chunk.css";
};